import { useRef } from "react";
import { downloadReport, userIcon } from "../../assets/images";
import { UiButton, UiDrawer, UiProfileModel } from "../../components";
import { downloadFileByUrl, formatPhoneNumber, playMediaByRef } from "../../utils/appUtils";
import SendMessageModal from "../sendMessageModel";
import dayjs from "dayjs";
import UiWarningRating from "../uiWarning";

const ComplaintView = ({
    consultationBooleans,
    handlComplaintsDetailClose,
    handleSendMessage,
    handleSendMessageClose,
    complaintIdData,
    handleConsultationComplaintReportOpen,
    handleMessageChange,
    handleMessageTabChange,
    messageData,
    handleMessageCheck,
    handleSubmitMessage,
    isButtonLoading,
    onRefund,
    isRefundDisabled = false,
    showWhatsapp = true
}) => {
    const data = complaintIdData?.data;
    const videoElementRef = useRef(null);
    const isRaisedByCustomer = data?.complaintType === "COMPLAINT_RAISED_CUSTOMER";
    const raisedByLabel = isRaisedByCustomer ? "Customer" : "Advocate";
    const againstByLabel = isRaisedByCustomer ? "Advocate" : "Customer";
    const nestedConsultationPaymentRecordDetail = data?.consultationDetails?.consultationPaymentDetails?.recordDetail;
    const recordingUrl = nestedConsultationPaymentRecordDetail?.recordingUrl || "";
    const hasRecordedFlag = nestedConsultationPaymentRecordDetail?.record;
    const isRecorded = nestedConsultationPaymentRecordDetail?.record === true || nestedConsultationPaymentRecordDetail?.isRecord === true || Boolean(recordingUrl);
    const isRecordingAvailable = Boolean(recordingUrl) || Boolean(hasRecordedFlag && recordingUrl);
    const consultationDetails = data?.consultationDetails;
    const consultationSessionDetails = consultationDetails?.consultationDetails;
    const consultationMinutes = consultationDetails?.consultationTime ?? data?.consultationTime;
    const formatDateTime = (dateTimeValue) => {
        return dateTimeValue ? dayjs(dateTimeValue).format("DD-MM-YYYY hh:mm:ss A") : "Nil";
    };

    const handlePlayRecord = () => {
        playMediaByRef(videoElementRef);
    };

    const handleDownloadRecord = () => {
        downloadFileByUrl(recordingUrl, "consultation-recording.mp4");
    };
    const isAlreadyRefunded = Boolean(
        consultationDetails?.refundId ||
        consultationDetails?.isRefunded ||
        consultationDetails?.refundStatus === "REFUNDED" ||
        consultationDetails?.refundStatus === "SUCCESS" ||
        Number(consultationDetails?.refundAmount || 0) > 0 ||
        data?.isRefunded ||
        data?.refundStatus === "REFUNDED" ||
        data?.refundStatus === "SUCCESS" ||
        Number(data?.refundAmount || 0) > 0
    );

    return <>
        <UiDrawer
            open={consultationBooleans?.isComplaintDrawerOpen}
            onClose={handlComplaintsDetailClose}
            title={"Complaint Details"}
            width={600}
            footer={<div className="flexible-end">
                {onRefund && (
                    <UiButton
                        type="primary"
                        disabled={isRefundDisabled}
                        onClick={onRefund}
                    >
                        {isAlreadyRefunded ? "Refunded" : "Refund"}
                    </UiButton>
                )}
                {consultationBooleans?.isDownloadButtonEnable ? <UiButton type="primary" onClick={handleConsultationComplaintReportOpen}><img src={downloadReport} alt="" />Download Report</UiButton> : ""}
                {
                    data?.complaintStatus === "PENDING" ? <>
                        <UiButton type="primary" onClick={() => handleSendMessage("sendMessage", complaintIdData)}>Send Message</UiButton>
                    </> : ""
                }
                <UiButton onClick={handlComplaintsDetailClose}>Close</UiButton>
            </div>}
        >
            <div>
                <div className="lawyer-information" style={{ margin: "10px 0px" }}>
                    <div style={{ borderBottom: "1px solid #000", padding: "10px 5px" }}>
                        <h3 className="lawyerInfo-heading">{againstByLabel}</h3>
                    </div>
                    <div className="flexible" style={{ borderBottom: "1px solid #000" }}>
                        <div className="flexible">
                            {
                                !complaintIdData?.againstByProfile || complaintIdData?.againstByProfile?.includes("null") || complaintIdData?.againstByProfile?.includes("undefined") || complaintIdData?.againstByProfile?.includes("[object Object]") ? <img src={userIcon} style={{ width: "50px", height: "50px", borderRadius: "50%", objectFit: "cover" }} alt="" /> : <UiProfileModel imageUrl={complaintIdData?.againstByProfile} />
                            }
                            <div>
                                <h3 className="lawerInfo-detail">{data?.againstByName || "Nil"}</h3>
                                {<div style={{ padding: "5px 10px" }}>
                                    <UiWarningRating count={data?.againstByWarningCount} />
                                </div>}
                            </div>
                        </div>
                        <div className="flexible">
                            <div>
                                <small className="information-header">{againstByLabel} ID</small>
                                <h3 className="lawerInfo-detail">{data?.againstByNo || "Nil"}</h3>
                            </div>
                        </div>
                    </div>
                    <div className="flexible">
                        <div>
                            <small className="information-header">Mobile Number</small>
                            <h3 className="lawerInfo-detail">{formatPhoneNumber(data?.againstByMobileNumber) || "Nil"}</h3>
                        </div>
                        <div>
                            <small className="information-header">E-mail Address</small>
                            <h3 className="lawerInfo-detail">{data?.againstByEmail || "Nil"}</h3>
                        </div>
                    </div>
                </div>
                <div className="lawyer-details">
                    <div>
                        <div style={{ borderBottom: "1px solid #00000054", paddingBottom: "10px" }}>
                            <h3 className="lawyerInfo-heading" >{raisedByLabel}</h3>
                        </div>
                        <div className="flexible">
                            <div>
                                <small className="information-header">Name</small>
                                <h3 className="lawerInfo-detail">{data?.raisedByName || "Nil"}</h3>
                            </div>
                            <div>
                                <small className="information-header">{raisedByLabel} ID</small>
                                <h3 className="lawerInfo-detail">{data?.raisedByNo || "Nil"}</h3>
                            </div>
                            <div>
                                <small className="information-header">Mail ID</small>
                                <h3 className="lawerInfo-detail">{data?.raisedByEmail || "Nil"}</h3>
                            </div>
                            <div>
                                <small className="information-header">Mobile Number</small>
                                <h3 className="lawerInfo-detail">{formatPhoneNumber(data?.raisedByMobileNumber) || "Nil"}</h3>
                            </div>
                        </div>
                    </div>
                    <div style={{ padding: "10px 0px" }}>
                        <div style={{ borderBottom: "1px solid #00000054", padding: "10px 0px" }}>
                            <div className="flexible">
                                <h3 className="lawyerInfo-heading">Complaint</h3>
                                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                    {
                                        data?.complaintStatus === "PENDING" ? <div className="pending-status" style={{ margin: 0 }}>
                                            <p style={{ padding: "5px" }}>Pending</p>
                                        </div> : <div className="success-status">
                                            <p style={{ padding: "5px" }}>Completed</p>
                                        </div>
                                    }
                                    <div className={isRecorded ? "success-status" : "danger-status"} style={{ margin: 0 }}>
                                        <p style={{ padding: "5px" }}>{isRecorded ? "Recorded" : "Not Recorded"}</p>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="flexible">
                            <div>
                                <small className="information-header">Complaint No</small>
                                <h3 className="lawerInfo-detail">{data?.complaintNo || "Nil"}</h3>
                            </div>
                            <div>
                                <small className="information-header">Complaint Date</small>
                                <h3 className="lawerInfo-detail">{data?.complaintDate ? dayjs(data?.complaintDate).format("DD-MM-YYYY") : "Nil"}</h3>
                            </div>
                            <div>
                                <small className="information-header">Cons. Date</small>
                                <h3 className="lawerInfo-detail">{data?.consultationDetails?.consultationDate ? dayjs(data?.consultationDetails?.consultationDate).format("DD-MM-YYYY") : "Nil"}</h3>
                            </div>
                             <div style={{ padding: "5px" }}>
                            <small className="information-header">Cons. ID</small>
                            <h3 className="lawerInfo-detail">{consultationDetails?.consultationNo || "Nil"}</h3>
                        </div>
                        </div>
                        <div style={{ borderTop: "1px solid #0000001f", marginTop: "10px", paddingTop: "10px" }}>
                            <div className="flexible" style={{ alignItems: "center" }}>
                                <h3 className="lawyerInfo-heading">Consultation Details</h3>
                                {consultationMinutes !== undefined && consultationMinutes !== null && consultationMinutes !== "" ? <div className="success-status" style={{ margin: 0 }}>
                                    <p style={{ padding: "5px" }}>{consultationMinutes} Min</p>
                                </div> : null}
                            </div>
                            <div className="flexible">
                                <div>
                                    <small className="information-header">Start Time</small>
                                    <h3 className="lawerInfo-detail">{formatDateTime(consultationDetails?.consultationStartTime || data?.consultationStartTime)}</h3>
                                </div>
                                <div>
                                    <small className="information-header">End Time</small>
                                    <h3 className="lawerInfo-detail">{formatDateTime(consultationDetails?.consultationEndTime || data?.consultationEndTime)}</h3>
                                </div>
                            </div>
                            <div className="flexible">
                                <div>
                                    <small className="information-header">Customer Join Time</small>
                                    <h3 className="lawerInfo-detail">{formatDateTime(consultationSessionDetails?.customerJoinTime || consultationDetails?.customerJoinTime)}</h3>
                                </div>
                                <div>
                                    <small className="information-header">Lawyer Join Time</small>
                                    <h3 className="lawerInfo-detail">{formatDateTime(consultationSessionDetails?.lawyerJoinTime || consultationDetails?.lawyerJoinTime)}</h3>
                                </div>
                            </div>
                            <div className="flexible">
                                <div>
                                    <small className="information-header">Customer Leave Time</small>
                                    <h3 className="lawerInfo-detail">{formatDateTime(consultationSessionDetails?.customerLeaveTime || consultationDetails?.customerLeaveTime)}</h3>
                                </div>
                                <div>
                                    <small className="information-header">Lawyer Leave Time</small>
                                    <h3 className="lawerInfo-detail">{formatDateTime(consultationSessionDetails?.lawyerLeaveTime || consultationDetails?.lawyerLeaveTime)}</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style={{ borderBottom: "1px solid #00000054", paddingBottom: "10px" }}>
                        <h3 className="lawyerInfo-heading">Description</h3>
                    </div>
                    <div> <p>{data?.complaintDescription || "Nil"}</p></div>
                    <div style={{ borderBottom: "1px solid #00000054", paddingBottom: "10px" }}>
                        <h3 className="lawyerInfo-heading">Lawyer Reply</h3>
                    </div>
                    <div> <p>{data?.lawyerReplayToComplaint || "Nil"}</p></div>
                    {
                        isRecordingAvailable && <div>
                            <div
                                style={{
                                    backgroundColor: '#d9d9d9',
                                    minHeight: '200px',
                                    borderRadius: '8px',
                                    marginBottom: '16px',
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    padding: "10px"
                                }}
                            >
                                <video
                                    ref={videoElementRef}
                                    src={recordingUrl}
                                    controls
                                    preload="metadata"
                                    data-testid="complaint-recording-video"
                                    style={{ width: "100%", maxHeight: "320px", borderRadius: "8px", backgroundColor: "#000" }}
                                />
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                                <UiButton
                                    type="default"
                                    style={{ backgroundColor: '#005D6033', color: '#005D60' }}
                                    onClick={handlePlayRecord}
                                >
                                    Play Record
                                </UiButton>
                                <UiButton
                                    style={{ backgroundColor: '#CCBA78', color: 'white' }}
                                    onClick={handleDownloadRecord}
                                ><img src={downloadReport} alt="" />Download Record</UiButton>
                            </div>
                        </div>
                    }
                </div>
                {
                    data?.complaintStatus === "COMPLETED" ? <div>
                        <h3 className="lawyerInfo-heading" style={{ padding: "5px" }}>Action Item</h3>
                        {data?.actionItemRaisedBy && <div>
                            <h3 className="lawyerInfo-heading" style={{ padding: "10px" }}>{raisedByLabel}</h3>
                            <div>
                                <p style={{ padding: "0px 10px" }}>{data?.actionItemRaisedBy || "Nil"}</p>
                            </div>
                        </div>
                        }
                        {
                            data?.actionItemAgainstBy && <div style={{ padding: 0, margin: 0 }}>
                                <h3 className="lawyerInfo-heading" style={{ padding: "10px" }}>{againstByLabel}</h3>
                                <div>
                                    <p style={{ padding: "0px 10px" }}>{data?.actionItemAgainstBy || "Nil"}</p>
                                </div>
                            </div>
                        }
                    </div> : ""
                }
            </div>
        </UiDrawer>
        <SendMessageModal open={consultationBooleans?.isSendMessage || consultationBooleans?.isSendWarningMessage}
            onClose={handleSendMessageClose}
            isWarning={consultationBooleans?.isSendWarningMessage}
            handleMessageChange={handleMessageChange}
            handleMessageTabChange={handleMessageTabChange}
            messageData={messageData}
            handleMessageCheck={handleMessageCheck}
            onSubmit={handleSubmitMessage}
            isButtonLoading={isButtonLoading}
            showWhatsapp={showWhatsapp}
        />
    </>
};
export default ComplaintView